
const initializers = {
    version: "2.0.0",
    api_host: "https://beta-legacy.astrnt.co",
    api_host_v2: "https://beta.astrnt.co",
};

export default initializers;

